<script setup lang="ts">
  interface ImageDarkModeProps {
    lightModeImage: string
    darkModeImage?: string
    withTagline?: boolean
  }

  const props = defineProps<ImageDarkModeProps>()

  function hasDarkModeImage() {
    return !!props.darkModeImage
  }

  const logoSizeClasses = computed(() => {
    return props.withTagline ? 'w-[24px] h-[24px]' : 'w-[117px] h-[24px]'
  })
</script>
<template>
  <template v-if="hasDarkModeImage()">
    <img
      :src="lightModeImage"
      :class="[logoSizeClasses, 'dark:hidden']"
      alt="Logo"
    />
    <img
      :src="darkModeImage"
      :class="[logoSizeClasses, 'hidden dark:block']"
      alt="Logo"
    />
  </template>
  <template v-else>
    <img
      :src="lightModeImage"
      :class="[
        logoSizeClasses,
        '[&_path]:stroke-black dark:[&_path]:stroke-white dark:filter dark:invert',
      ]"
      alt="Logo"
    />
  </template>
</template>
